import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import PricingPage from '@/pages/PricingPage';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import SubscriptionPage from '@/pages/SubscriptionPage';
import MarketingHub from '@/pages/MarketingHub';
import TeamsPage from '@/pages/TeamsPage';
import LandingPage from '@/pages/LandingPage';
import BlogPage from '@/pages/BlogPage';
import BlogAdmin from '@/pages/BlogAdmin';
import SupportPage from '@/pages/SupportPage';
import ProfilePage from '@/pages/ProfilePage';
import TermsPage from '@/pages/TermsPage';
import PrivacyPage from '@/pages/PrivacyPage';
import BookingPage from '@/pages/BookingPage';
import ProtectedRoute from '@/components/ProtectedRoute';

const App = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[var(--main-bg)]">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[var(--obsidian)] border-t-transparent animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Loading VAULT...
          </p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/register" element={user ? <Navigate to="/dashboard" replace /> : <Register />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/book" element={<BookingPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route
        path="/subscription"
        element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>}
      />
      <Route
        path="/marketing"
        element={<ProtectedRoute><MarketingHub /></ProtectedRoute>}
      />
      <Route
        path="/teams"
        element={<ProtectedRoute><TeamsPage /></ProtectedRoute>}
      />
      <Route
        path="/blog-admin"
        element={<ProtectedRoute><BlogAdmin /></ProtectedRoute>}
      />
      <Route
        path="/support"
        element={<ProtectedRoute><SupportPage /></ProtectedRoute>}
      />
      <Route
        path="/profile"
        element={<ProtectedRoute><ProfilePage /></ProtectedRoute>}
      />
      <Route
        path="/admin"
        element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>}
      />
      <Route
        path="/dashboard"
        element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
      />
      <Route
        path="/"
        element={
          user
            ? <Navigate to="/dashboard" replace />
            : <LandingPage />
        }
      />
      <Route
        path="*"
        element={
          user
            ? <ProtectedRoute><Dashboard /></ProtectedRoute>
            : <Navigate to="/" replace />
        }
      />
    </Routes>
  );
};

export default App;
